/* platforms.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;

const formatters = require("../../../cellFormaters");
const mapDataFormatters = require("../../../cellFormaters/mapDataFormatters");
const mdCheckBoxEditor = require("../../../cellEditors/MapData/CheckBoxEditor");
const checkBoxEditor = require("../../../cellEditors/CheckBoxEditor");
const vendorEditor = require("../../../cellEditors/MapData/VendorEditor");
const netBoxPlatformsEditor = require("../../../cellEditors/MapData/NetBoxPlatformsEditor");
const platformsEditor = require("../../../cellEditors/MapData/PlatformsEditor");
const getDefaultCreateValue = require("../../../cellEditors/MapData/mapDataUtil");

function createWithContext(context) {
    let ctx = context;
    let allGluPlatforms = {};
    ctx._isPlatformsDataValid = false;
    ctx._createPlatformsContent = function () {
        const slickTablePlatformsContainerMain = document.createElement(
            "slick-table-cmdb-container"
        );
        ctx._slickTablePlatformsContainer = document.createElement("slick-table-cmdb");
        ctx._addNewPlatformRowButton = new Button({
            label: "Add Platform +",
            active: true,
        });

        slickTablePlatformsContainerMain.appendChild(ctx._slickTablePlatformsContainer);

        const addRowButtonContainer = document.createElement("div");
        addRowButtonContainer.classList.add("add-new-rule-container");
        addRowButtonContainer.appendChild(ctx._addNewPlatformRowButton._renderer._rootElem);
        slickTablePlatformsContainerMain.appendChild(addRowButtonContainer);

        ctx._slickPlatformsTable = undefined;
        ctx._maxSortOrderPlatforms = 0;

        ctx._columnsPlatforms = [
            {
                id: "order",
                width: 10,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute("title", "Reorder");
                },
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered g-icon-drag",
                headerCssClass: "centered",
            },
            {
                id: "vendor",
                field: "vendor",
                width: 266,
                name: "Gluware Vendor",
                tooltip: "Vendor",
                resizable: false,
                formatter: mapDataFormatters.vendorFormatter,
                editor: vendorEditor,
            },
            {
                id: "regex",
                field: "regex",
                width: 90,
                name: "RegEx",
                tooltip: "RegEx",
                resizable: false,
                headerCssClass: "centered",
                formatter: mapDataFormatters.regexCheckboxFormatter,
                editor: mdCheckBoxEditor,
            },
            {
                id: "platform",
                field: "platform",
                width: 290,
                name: "Gluware OS Platform",
                tooltip: "Gluware OS Platform",
                resizable: false,
                formatter: mapDataFormatters.platformFormatter,
                editor: platformsEditor,
            },
            {
                id: "create",
                field: "create",
                width: 90,
                name: "Create",
                tooltip: "Create",
                resizable: false,
                headerCssClass: "centered",
                formatter: formatters.checkboxFormatter,
                editor: checkBoxEditor,
            },
            {
                id: "netBoxPlatform",
                field: "netBoxPlatform",
                width: 290,
                name: "NetBox Platform",
                tooltip: "NetBox Platform",
                resizable: false,
                formatter: mapDataFormatters.netboxPlatformFormatter,
                editor: netBoxPlatformsEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: mapDataFormatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        ctx._platformsContainer.appendChild(slickTablePlatformsContainerMain);
        ctx._platformsContainer.appendChild(ctx._pCreateUnmappedCheckbox.renderer.getRootElement());

        allGluPlatforms = ctx._getAvailableSortedValues(ctx.getGluPlatforms());
    };

    ctx.registerPlatformListeners = function () {
        ctx._addNewPlatformRowButton.on(
            "UserClick",
            (ctx._onAddNewPlatform = ctx._onAddNewPlatform.bind(ctx))
        );
    };
    ctx.unregisterPlatformListeners = function () {
        ctx._addNewPlatformRowButton.removeAllListeners();
        ctx._unregisterPlatformsSlickTableListeners();
    };

    ctx._registerPlatformsSlickTableListeners = function () {
        if (ctx._slickPlatformsTable) {
            ctx._slickPlatformsTable.onCellChange.subscribe(ctx._onPlatformsCellChangeAction);
            ctx._slickPlatformsTable.onBeforeEditCell.subscribe(ctx._onBeforeEditCell);
            ctx._slickPlatformsTable
                .getContainerNode()
                .addEventListener("RowOrderChanged", ctx._onPlatformsRowsChanged);
        }
    };

    ctx._unregisterPlatformsSlickTableListeners = function () {
        if (ctx._slickPlatformsTable) {
            ctx._slickPlatformsTable.onCellChange.unsubscribe(ctx._onPlatformsCellChangeAction);
            ctx._slickPlatformsTable.onBeforeEditCell.unsubscribe(ctx._onBeforeEditCell);
            ctx._slickPlatformsTable
                .getContainerNode()
                .removeEventListener("RowOrderChanged", ctx._onPlatformsRowsChanged);
        }
    };

    ctx._resetPlatformsGrid = function (data) {
        if (!data) {
            data = ctx._getPlatformsGridData();
        }
        if (ctx._slickPlatformsDataView) {
            ctx._slickPlatformsDataView.setItems(data);
        }
        ctx._resetPlatformsGridView(data);
    };

    ctx._resetPlatformsGridView = function (data) {
        ctx._toggleNoDataPlaceholder(!data.length, ctx._slickTablePlatformsContainer);
        ctx._enableDisableAutoCreate(!data.length, ctx._pCreateUnmappedCheckbox);
        // ctx._sortTable();
        if (ctx._slickPlatformsTable) {
            ctx._slickPlatformsTable.invalidate();
            ctx._slickPlatformsTable.render();
            ctx._slickPlatformsTable.resizeCanvas();
        }
    };

    ctx._renderPlatformsSlickGrid = function (data) {
        const platformsData = data || ctx._getPlatformsGridData() || [];
        if (!ctx._slickPlatformsTable) {
            ctx._slickTablePlatformsContainer.style.height = (platformsData.length + 1) * 80 + "px";
            ctx._slickPlatformsDataView = new Slick.Data.DataView();
            ctx._slickPlatformsDataView.setItems(platformsData);
            ctx._slickPlatformsTable = new Slick.Grid(
                ctx._slickTablePlatformsContainer,
                ctx._slickPlatformsDataView,
                ctx._columnsPlatforms,
                ctx._tableOptions
            );

            ctx._registerPlatformsSlickTableListeners();
            // ctx._slickPlatformsTable.maxSortOrder = ctx._maxSortOrder;
            ctx._slickPlatformsTable.setSelectionModel(new Slick.RowSelectionModel());
            ctx._registerRowMovePlugin(ctx._slickPlatformsTable, ctx._slickPlatformsDataView);

            ctx._slickTablePlatformsContainer.appendChild(ctx._createNoDataPlaceholder());
            ctx._toggleNoDataPlaceholder(!platformsData.length, ctx._slickTablePlatformsContainer);
            ctx._enableDisableAutoCreate(!platformsData.length, ctx._pCreateUnmappedCheckbox);
            ctx.registerPlatformListeners();
            ctx._slickTablePlatformsContainer.style.height = "auto";
            // setTimeout(ctx._resetPlatformsGrid(), 1000);
        } else {
            // ctx._resetPlatformsData(ctx._model._selectedClass);
            ctx._resetPlatformsGrid();
        }
    };

    ctx._getPlatformsGridData = function () {
        const data = ctx.getPlatformsMapping() || [];
        return data.map((item) => ctx._getPlatformRow(item));
    };

    ctx._getPlatformRow = function (item) {
        const metaData = ctx._metaData;
        const vendorOptions = ctx._vendorOptions;
        const nbPlatformOptions = ctx._nbPlatformOptions;
        const gluPlatforms = ctx.getGluPlatforms();
        let defaultVendor,
            defaultPlatform,
            defaultRegex = false,
            unAvailable = false,
            defaultNetBoxName,
            defaultNbPlatform = nbPlatformOptions[0] && nbPlatformOptions[0].value;
        if (!item) {
            const vendorsList = Object.keys(gluPlatforms);
            for (let i = 0; i < vendorsList.length; i++) {
                const ven = vendorsList[i];
                const pfKeys = Object.keys(gluPlatforms[ven]);
                const keySet = pfKeys.some((key) => {
                    if (gluPlatforms[ven][key]) {
                        defaultPlatform = key;
                        defaultVendor = ven;
                        return true;
                    }
                });
                if (keySet) {
                    defaultNetBoxName = getDefaultCreateValue(
                        defaultVendor,
                        defaultPlatform,
                        vendorOptions
                    );
                    break;
                }
            }
            if (!defaultVendor) {
                defaultVendor = "ALL";
                defaultRegex = true;
                defaultPlatform = ".*";
                unAvailable = true;
                defaultNetBoxName = getDefaultCreateValue(defaultVendor, undefined, vendorOptions);
            }
            return {
                id: parseInt(Math.random() * 10000, 10),
                vendor: defaultVendor,
                regex: defaultRegex,
                platform: defaultPlatform,
                pfRegex: ".*",
                pfValue: defaultPlatform,
                create: false,
                netBoxPlatform: defaultNbPlatform,
                netBoxId: defaultNbPlatform,
                netBoxName: defaultNetBoxName,
                isUnavailable: unAvailable,
                metaData,
                vendorOptions,
                nbPlatformOptions,
                allGluPlatforms,
            };
        }

        defaultNetBoxName = getDefaultCreateValue(
            item.vendor,
            item.isRegEx ? undefined : item.platform,
            vendorOptions
        );

        return {
            id: item.id || Math.random() * 10000,
            vendor: item.vendor,
            regex: item.isRegEx,
            platform: item.platform,
            pfRegex: item.isRegEx ? item.platform : ".*",
            pfValue: item.isRegEx ? "" : item.platform,
            create: item.createMissing,
            netBoxPlatform: item.netBoxId || item.netBoxName,
            netBoxId: item.netBoxId,
            netBoxName: item.netBoxName || item.vendor + " - " + item.platform,
            metaData,
            vendorOptions,
            nbPlatformOptions,
            allGluPlatforms,
        };
    };

    ctx._formatPlatformsGridToMapping = function (data) {
        const platformsDataMapping = data.map((item) => {
            const platformObj = {};
            platformObj.vendor = item.vendor;
            platformObj.createMissing = item.create;
            platformObj.isRegEx = item.regex;
            platformObj.platform = item.platform;
            if (item.create) {
                platformObj.netBoxId = undefined;
                platformObj.netBoxName = item.netBoxName;
            } else {
                platformObj.netBoxId = item.netBoxId;
            }
            return platformObj;
        });
        return platformsDataMapping;
    };

    let _validateRowData = function (data, item, idx) {
        if (!item) {
            return;
        }
        if (item.create && !item.netBoxName) {
            return false;
        }
        if (item.regex && !item.pfRegex) {
            return false;
        }
        const refVendor = item.vendor;
        const refPlatform = item.regex ? undefined : item.platform;
        const itemMatches = data.some((item, currIdx) => {
            // if(item.regex) {
            //     if(idx !== currIdx && (item.vendor === refVendor)) {
            //         return true;
            //     }
            //     return false;
            // }
            if (idx !== currIdx && item.vendor === refVendor && item.platform === refPlatform) {
                return true;
            }
            return false;
        });
        if (itemMatches) {
            ctx._isPlatformsDataValid = false;
            item.isValid = false;
        } else {
            item.isValid = true;
        }
        return item.isValid;
    };

    let _validateGridData = function (data) {
        const invalidRows = [];
        data.forEach((item, idx) => {
            if (!_validateRowData(data, item, idx)) {
                ctx._slickPlatformsTable &&
                    ctx._slickPlatformsTable.getCellNode(idx, 0) &&
                    ctx._slickPlatformsTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .addClass("invalid");
                invalidRows.push(idx);
            } else {
                ctx._slickPlatformsTable &&
                    ctx._slickPlatformsTable.getCellNode(idx, 0) &&
                    ctx._slickPlatformsTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .removeClass("invalid");
            }
        });
        ctx._isPlatformsDataValid = !invalidRows.length;
        return ctx._isPlatformsDataValid;
    };

    ctx._validatePlatformsData = function () {
        if (!ctx._slickPlatformsDataView) {
            return true;
        }
        _validateGridData(ctx._slickPlatformsDataView.getItems());
        return ctx._isPlatformsDataValid;
    };

    ctx._setPlatformsData = function () {
        const platformsData = {};
        const data = ctx._slickPlatformsDataView.getItems();
        platformsData.mapping = ctx._formatPlatformsGridToMapping(data);
        platformsData.createUnmapped = ctx._pCreateUnmappedCheckbox.getValue();
        // console.log(platformsData);
        ctx._setPlatformsDataToEty(platformsData);
        ctx.emit("ValueChange");
        return true;
    };

    ctx._setPlatformsDataToEty = function (data) {
        const platformsData = ctx.getPlatformsData() || {};
        platformsData.createUnmapped = data.createUnmapped;
        platformsData.mapping = data.mapping;
        const dataSyncMapping = ctx._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.platforms", platformsData);
        ctx._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
    };

    ctx._onAddNewPlatform = function () {
        // console.log("add platform");
        const newRow = ctx._getPlatformRow();
        const data = ctx._slickPlatformsDataView.getItems();
        data.push(newRow);
        ctx._resetPlatformsGrid(data);
        _validateGridData(data);
        ctx._setPlatformsData();
    };

    ctx._deletePlatform = function (id) {
        const deleteMessage = `Are you sure you want to delete the "Platform Mapping"?`;
        return ctx
            ._deleteConfirmation(deleteMessage)
            .then(() => {
                ctx._slickPlatformsDataView.deleteItem(id);
                const data = ctx._slickPlatformsDataView.getItems();
                ctx._resetPlatformsGridView(data);
                _validateGridData(data);
                ctx._setPlatformsData();
            })
            .catch((error) => error && ctx._showError(error));
    };

    ctx._onPlatformsCellChangeAction = function (/*evt, args*/) {
        const data = ctx._slickPlatformsDataView.getItems();
        _validateGridData(data);
        ctx._setPlatformsData();
    }.bind(ctx);

    ctx._onPlatformsRowsChanged = function (/*evt, args*/) {
        const data = ctx._slickPlatformsDataView.getItems();
        _validateGridData(data);
        ctx._setPlatformsData();
    }.bind(ctx);
}

module.exports = createWithContext;
